import * as React from 'react'

import { getOrderFromUrl } from '~logic/helpers/getOrderFromUrl'

import { PaymentLockedOrderProvider } from './contexts/PaymentLockedOrderProvider'
import { PaymentLockedScreenResponsiveContent } from './PaymentLockedScreenResponsiveContent'

type TProps = NoChildren

/**
 * The screen where the payment is still active in the payment gateway.
 */
export const PaymentLockedScreen: React.FC<TProps> = () => {
  const { orderId, userToken } = getOrderFromUrl()

  if (!orderId || !userToken) {
    // to use order tracking, orderId and userToken must be present in the URL params
    // otherwise we couldn’t access the order -> redirect to homepage
    // this is actually handled in the paymentLockedScreenSS
    // so this code should never run with current implementation
    return null
  }
  // present simple UI with a link to the payment GW
  // (use the first link that is not null, if all are null, generic error & Sentry)
  return (
    <PaymentLockedOrderProvider orderId={orderId}>
      <PaymentLockedScreenResponsiveContent />
    </PaymentLockedOrderProvider>
  )
}
